export const GET_AUDIT_TRANSACTIONS = "GET_AUDIT_TRANSACTIONS";
export const SET_AUDIT_TRANSACTIONS = "SET_AUDIT_TRANSACTIONS";
export const GET_AUDIT_TRANSACTIONS_TO_PRINT = "GET_AUDIT_TRANSACTIONS_TO_PRINT";